import {isLoggedIn} from '@/api';
import {ReactElement, ReactNode} from 'react';
import {Navigate, Outlet, useLocation} from 'react-router';

interface Props {
	children?: ReactNode,
}

export default function PrivateRoute({children}: Props): ReactElement | ReactNode {
	const location = useLocation();

	if (!isLoggedIn()) {
		let path = '/login';

		if (location.pathname !== '/login')
			path += '?redirect=' + location.pathname;

		return <Navigate to={path} replace={true} />;
	}

	return children ?? <Outlet />;
}
